'use client';

import { Box, List, ListItem, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';
import { Link } from 'src/i18n/routing';
import { color, spacing } from 'src/theme/tokens';
import { typography as dsTypography } from 'src/theme/typography';
import { FooterNavGroup } from './footer.config';

const ItemText = styled('span')(() => ({
    ...dsTypography.label5medium,
    color: color.white[0],
}));

type Props = {
    group: FooterNavGroup;
};

export default function FooterNav({ group }: Props) {
    const t = useTranslations();

    const FooterLink = styled(Link)`
        color: ${color.white[0]};
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
        &:visited {
            color: ${color.white[0]};
        }
        &:focus {
            outline: none;
        }
        &:focus-visible {
            outline: 2px solid ${color.white[0]};
            outline-offset: 2px;
        }
    `;

    return (
        <Box display="flex" flexDirection="column" gap={spacing[20]}
            maxWidth={
                { xs: '144px', sm: '158px', md: '192px' }
            }
            width="100%"
            sx={{ minWidth: { xs: 'unset', sm: '158px', md: '192px' } }}
        >
            <Typography variant="label5bold" component="h2" color={color.white[0]}>{t(group.titleKey)}</Typography>
            <List sx={{ display: 'flex', flexDirection: 'column', gap: spacing[12], padding: 0, listStyle: 'none' }}>
                {group.items.map(item => (
                    <ListItem key={item.labelKey} sx={{ padding: 0 }}>
                        <FooterLink href={item.href} target={item.external ? '_blank' : undefined} rel={item.external ? 'noopener noreferrer' : undefined}>
                            <ItemText>{t(item.labelKey)}</ItemText>
                        </FooterLink>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}


